import { render, staticRenderFns } from "./myAttention.vue?vue&type=template&id=2bb94c34&scoped=true"
import script from "./myAttention.vue?vue&type=script&lang=js"
export * from "./myAttention.vue?vue&type=script&lang=js"
import style0 from "./myAttention.vue?vue&type=style&index=0&id=2bb94c34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb94c34",
  null
  
)

export default component.exports